import { defineStore } from "pinia";
const useConfigStore = defineStore("magentoConfig", {
  state: () => ({
    storeConfig: {},
    stores: [],
    currency: {},
    blockCache: {}
  }),
  getters: {
    arePricesIncludingTax: (state) => {
      const tax = state.storeConfig.catalog_display_tax || "1";
      return parseInt(tax) > 1;
    }
  }
});
export {
  useConfigStore
};
